/** @format */

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import { HasErrors } from '../../Logic/ServerResponse';
import { ConstantState, ConstantsInitialState } from './Models';
import { fetchAllConstants } from './constantsApi';

const initialState: ConstantsInitialState = {
  constantState: {} as ConstantState,
};

export const fetchAllConstantsThunk = createAsyncThunk(
  'constants/all',
  async () => {
    let response: any;
    await fetchAllConstants()
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const constantsSlice = createSlice({
  name: 'constants',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllConstantsThunk.pending, (state) => {
        state.constantState.status = 'loading';
      })
      .addCase(fetchAllConstantsThunk.fulfilled, (state, action) => {
        const hasErrors = HasErrors(action);
        if (hasErrors === 1) {
          state.constantState.status = 'failed';
          state.constantState.error = action.payload;
        } else if (hasErrors === 3 || hasErrors === 2) {
          state.constantState.gender = action.payload.data.gender;
          state.constantState.applicationStages = action.payload.data.applicationStages;
          state.constantState.race = action.payload.data.race;
          state.constantState.provinces = action.payload.data.provinces;
          state.constantState.institutionTypes =
            action.payload.data.institutionTypes;
          state.constantState.universities = action.payload.data.universities;
          state.constantState.documentOwners = action.payload.data.documentOwners;
          state.constantState.documentTypes = action.payload.data.documentTypes;
          state.constantState.subjects = action.payload.data.subjects;
          state.constantState.typeOfStudies = action.payload.data.typeOfStudies;
          state.constantState.yearOfStudies = action.payload.data.yearOfStudies;
          state.constantState.guardianTypes = action.payload.data.guardianTypes;
          state.constantState.businessTypes = action.payload.data.businessTypes;
          state.constantState.employmentStatus = action.payload.data.employmentStatus;
          state.constantState.applicationDeclineReasons = action.payload.data.applicationDeclineReasons;
          state.constantState.guardianTypesOptions =
            action.payload.data.guardianTypesOptions;
            
          state.constantState.status = 'idle';
        }
      })
      .addCase(fetchAllConstantsThunk.rejected, (state, action) => {
        state.constantState.status = 'failed';
        state.constantState.error = action.payload;
      });
  },
});

export const {} = constantsSlice.actions;
export const selectConstants = (state: RootState) => state.constants;
export default constantsSlice.reducer;
